
<h2>TO Do's Tschockl</h2>
<div class="example-container">
   
    <div class="example-container">
        <mat-form-field>
          <mat-label>Enter your password</mat-label>
          <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" [(ngModel)]="myPassword" (input)="onPasswordInput()">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      
        <!--h5>{{myPassword}}</h5-->
      </div>
<div *ngIf="hidecode">
<table mat-table class="lessons-table mat-elevation-z8" [dataSource]="ToDoP">
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  
    name?: string;
    date?: string;
    state?: number;
    finishdate?: string;
    note?: string;
    <ng-container matColumnDef="name">

         <th mat-header-cell *matHeaderCellDef>name</th>
        <td mat-cell *matCellDef="let lesson" [ngStyle]="{'background-color': getStateColor(lesson.state)}">{{lesson.name}}</td>

        <!--td *matCellDef="let lesson">{{lesson.name}}</td-->
        <td mat-footer-cell *matFooterCellDef></td> 
    </ng-container>
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>date</th>
        <td *matCellDef="let lesson"  [ngStyle]="{'background-color': getStateColor(lesson.state)}">{{lesson.date}}</td>
        <td mat-footer-cell *matFooterCellDef></td> 
    </ng-container>
    <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>state</th>
        <td *matCellDef="let lesson"  [ngStyle]="{'background-color': getStateColor(lesson.state)}"><font color=green>{{lesson.state}}</font></td>
        <td mat-footer-cell *matFooterCellDef> </td> 
    </ng-container>

    <ng-container matColumnDef="finishdate">
        <th mat-header-cell *matHeaderCellDef>finishdate</th>
        <td *matCellDef="let lesson"  [ngStyle]="{'background-color': getStateColor(lesson.state)}"><font color=red>{{lesson.finishdate}}</font></td>
        <td mat-footer-cell *matFooterCellDef></td> 
    </ng-container>
    <ng-container matColumnDef="note">
        <th mat-header-cell *matHeaderCellDef>bemerkung</th>
        <td *matCellDef="let lesson"  [ngStyle]="{'background-color': getStateColor(lesson.state)}">{{lesson.note}}</td>
        <td mat-footer-cell *matFooterCellDef></td> 
    </ng-container>


    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" class="footer-row"></tr>
</table>





</div>